<div class="date-input-wrapper">
  <input
    [(ngModel)]="ngModelVar"
    [disabled]="isDisable"
    class="form-control {{isNotEndDateUserInfo && !ngModelVar  }} {{moreClass}}"
    (click)="showPicker($event)"
    [placeholder]="placeholder"
    style="caret-color: transparent;cursor: pointer;"
  />
  <input
    *ngIf="!isDisable"
    type="date"
    class="form-control {{isNotEndDateUserInfo && !ngModelVar  }}"
    style="height: 0px; width: 0px; opacity: 0;margin-top:-38px;"
    [min]="min"
    [max]="max"
    [(ngModel)]="dateFormatValue"
    [disabled]="isDisable"
    (input)="changeInputDate($event)"
    #myinput
  />
</div>
